<template>
	<div>
		<user-signup-modal v-if="showUserSignupModal" @close="closeSignupModal" />
		<div class="stage">
			<div class="row ml-1">
				<h1 class="font-medium">Users</h1>
			</div>
			<div v-if="$global.hasUserRole(userRoles, 'users:create')" class="row mb-2">
				<div class="col-xs-12 col-sm-12 col-md-12">
					<ul class="btnList">
						<li>
							<a class="jmiBtn green withIcon" @click="signupUser()"
								><span class="fa-light fa-plus"></span>New User Signup</a
							>
						</li>
					</ul>
				</div>
			</div>
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<p class="filter-label">Search</p>
					<div class="formGroup withIcon">
						<input v-model="searchTerm" placeholder="Search..." />
					</div>
				</div>
			</div>
			<div class="row hideMobile">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div class="listHeader">
						<div class="row">
							<div class="col-xs-12 col-sm-3 col-md-2" @click="setSort('name', !reverse)">
								<p>
									Name
									<span
										v-if="sortColumn === 'name'"
										:class="{
											'fa-light fa-chevron-down': reverse,
											'fa-light fa-chevron-up': !reverse
										}"
									></span>
								</p>
							</div>
							<div class="col-xs-12 col-sm-3 col-md-3 col-lg-2" @click="setSort('name', !reverse)">
								<p>
									Email
									<span
										v-if="sortColumn === 'name'"
										:class="{
											'fa-light fa-chevron-down': reverse,
											'fa-light fa-chevron-up': !reverse
										}"
									></span>
								</p>
							</div>
							<div class="col-xs-12 col-md-2 hideTabletLandscape" @click="setSort('id', !reverse)">
								<p>
									Provider
									<span
										v-if="sortColumn === 'name'"
										:class="{
											'fa-light fa-chevron-down': reverse,
											'fa-light fa-chevron-up': !reverse
										}"
									></span>
								</p>
							</div>

							<div
								v-if="$global.hasUserRole(userRoles, 'reseller')"
								class="col-xs-12 col-sm-2 hideTablet"
							>
								<p>Reseller</p>
							</div>
							<div
								v-if="tenants?.length > 1 || $global.hasUserRole(userRoles, 'reseller')"
								class="col-xs-12 col-sm-2"
							>
								<p>Tenants</p>
							</div>
							<div class="col-xs-12 col-sm-2">
								<p>Accounts</p>
							</div>
							<div class="col-xs-12 col-md-2 hideTabletLandscape" @click="setSort('createdAt', !reverse)">
								<p>
									Date Added
									<span
										v-if="sortColumn === 'createdAt'"
										:class="{
											'fa-light fa-chevron-down': reverse,
											'fa-light fa-chevron-up': !reverse
										}"
									></span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<transition-fade easing="ease-in">
				<div v-show="!loading" class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 tableOverflow">
						<router-link
							v-for="u in filteredUsers"
							:key="u.id"
							class="card listItem"
							:to="'/users/' + u.id"
						>
							<div class="row content middle-sm middle-md middle-lg">
								<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
									<div class="row middle-sm middle-md middle-lg">
										<div class="col-xs-12 col-sm-3 col-md-2">
											<p
												@mouseover="
													createTooltip(
														$event,
														u.id.indexOf('@clients') > -1 ? 'API User' : u.auth0?.name
													)
												"
											>
												{{ u.id.indexOf('@clients') > -1 ? 'API User' : u.auth0?.name }}
											</p>
										</div>
										<div class="col-xs-12 col-sm-3 col-md-3 col-lg-2">
											<p
												@mouseover="
													createTooltip(
														$event,
														u.id.indexOf('@clients') > -1 ? u.id : u.auth0?.email
													)
												"
											>
												{{ u.id.indexOf('@clients') > -1 ? u.id : u.auth0?.email }}
											</p>
										</div>
										<div class="col-xs-12 col-md-2 hideTabletLandscape">
											<p @mouseover="createTooltip($event, userProvider(u))">
												{{ userProvider(u) }}
											</p>
										</div>

										<div
											v-if="$global.hasUserRole(userRoles, 'reseller')"
											class="col-xs-12 col-sm-2"
										>
											<p @mouseover="createTooltip($event, u.reseller?.companyName)">
												{{ u.reseller?.companyName }}
											</p>
										</div>
										<div
											v-if="tenants.length > 1 || $global.hasUserRole(userRoles, 'reseller')"
											class="col-xs-12 col-sm-2"
										>
											<p
												@mouseover="
													createTooltip(
														$event,
														u.tenants?.map((t) => t.companyName).join(', ')
													)
												"
											>
												{{ u.tenants?.map((t) => t.companyName).join(', ') }}
											</p>
										</div>
										<div class="col-xs-12 col-sm-2">
											<p
												@mouseover="
													createTooltip($event, u.accounts?.map((a) => a.name).join(', '))
												"
											>
												{{ u.accounts?.map((a) => a.name).join(', ') }}
											</p>
										</div>
										<div class="col-xs-12 col-md-1 hideTabletLandscape">
											<p @mouseover="createTooltip($event, $global.dateFormat(u.createdAt))">
												{{ $global.dateFormat(u.createdAt) }}
											</p>
										</div>
										<div
											class="col-sm-1 end-sm end-md end-lg absolute bottom-4 right-4 sm:bottom-auto md:right-0"
										>
											<dropdown-menu
												v-if="$global.hasUserRole(userRoles, 'users:update')"
												class="dropdownTextLeft dropdownMed"
												:items="[
													{
														handler: () => {
															routeTo('/users/' + u.id)
														},
														icon: 'fa-light fa-pencil',
														label: 'Edit'
													}
													// {
													//     handler: () => {
													//         deleteUser(u)
													//     },
													//     icon: 'fa-light fa-delete-left',
													//     label: 'Delete'
													// }
												]"
											>
												<template #image>
													<button
														class="flex h-6 w-full flex-row items-center justify-center rounded-sm bg-blue-500 px-4 text-white hover:bg-blue-600"
														style="color: white"
														aria-label="Action Button"
													>
														<span class="m-0 flex flex-row items-center justify-center">
															<p class="flex sm:hidden lg:flex">Action</p>
															<span
																class="fa-light fa-chevron-down ml-2 sm:m-0 lg:ml-2"
															></span>
														</span>
													</button>
												</template>
											</dropdown-menu>
										</div>
									</div>
								</div>
							</div>
						</router-link>
					</div>
					<div
						v-if="!users || !users.length"
						class="card no-action listItem orange mx-auto w-[calc(100%-1rem)]"
					>
						<div class="row content middle-sm middle-md middle-lg">
							<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
								<div class="row middle-sm middle-md middle-lg">
									<div class="col-xs-12 mobileMargin-b20">
										<p>No users found.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</transition-fade>
			<transition-fade easing="ease-in">
				<div v-show="loading" class="row margin-b20 center-xs center-md center-lg">
					<div v-show="loading" class="loader"></div>
				</div>
			</transition-fade>
		</div>
	</div>
</template>

<script>
import usersApi from '../scripts/users/users.api'
import { router } from '../router'

export default {
	inject: ['user', 'tenants', 'userRoles'],
	data() {
		return {
			users: [],
			searchTerm: '',
			sortColumn: '',
			reverse: false,
			loading: true,
			showUserSignupModal: false,
			searchOptions: [],
			selectedSearchFilters: [],
			totalUsers: 0,
			currentPage: 1,
			pageSize: 10
		}
	},

	computed: {
		filteredUsers() {
			if (this.selectedSearchFilters && this.selectedSearchFilters.length > 0) {
				return this.users.filter((user) => {
					return this.selectedSearchFilters.some((filter) => {
						const searchValue = filter.toLowerCase()
						return (
							user.id.toLowerCase().includes(searchValue) ||
							(user.auth0?.name && user.auth0.name.toLowerCase().includes(searchValue)) ||
							(user.auth0?.email && user.auth0.email.toLowerCase().includes(searchValue))
						)
					})
				})
			} else if (this.searchTerm) {
				return this.users.filter((u) => {
					return (
						u.id.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1 ||
						(u.auth0?.name && u.auth0.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1) ||
						(u.auth0?.email && u.auth0.email.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1)
					)
				})
			} else {
				return this.users
			}
		}
	},

	created() {
		try {
			this.refreshUsers()
		} catch (e) {
			this.$swal({
				title: 'Error loading users',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/')
			})
			console.error(e)
		}
	},

	methods: {
		closeSignupModal() {
			this.showUserSignupModal = false
			this.refreshUsers()
		},
		routeTo(routeName) {
			router.push(routeName)
		},
		setSort(column, reverse) {
			if (this.sortColumn !== column) this.reverse = false
			else this.reverse = reverse

			this.sortColumn = column

			this.refreshUsers()
		},
		signupUser() {
			this.showUserSignupModal = true
		},
		userProvider(user) {
			if (user.auth0?.identities[0]?.provider === 'google-oauth2') return 'Google'
			if (user.auth0?.identities[0]?.provider === 'windowslive') return 'Microsoft'
			if (user.auth0?.identities[0]?.provider === 'linkedin') return 'LinkedIn'
			if (user.auth0?.identities[0]?.provider === 'auth0') return 'Username / Password'
			else return 'Other'
		},
		deleteUser(user) {
			if (user) {
				this.$swal({
					title: 'Delete User',
					text: `Would you like to delete user '${user.auth0?.name}'?`,
					showCancelButton: true,
					confirmButtonText: 'Delete',
					cancelButtonText: 'Cancel',
					showDenyButton: false,
					denyButtonText: 'Cancel'
				}).then((result) => {
					if (result.isConfirmed)
						usersApi.delete(user.id).then(() => {
							this.refreshUsers()
						})
				})
			}
		},

		async refreshUsers() {
			try {
				this.loading = true
				let params = {
					order: this.sortColumn
				}

				if (!this.reverse) params.dir = 'asc'

				const response = await usersApi.getAll(params)
				this.totalUsers = response.data.count
				this.users = response.data.results

				const maxPages = Math.ceil(this.totalUsers / this.pageSize) || 1
				if (this.currentPage > maxPages) {
					this.currentPage = 1
					this.refreshUsers()
					return
				}

				this.updateSearchOptions()
			} catch (err) {
				console.error(err)
			} finally {
				this.loading = false
			}
		},
		handleSearchChange(value) {
			this.selectedSearchFilters = Array.isArray(value) ? value : value ? [value] : []
		},
		updateSearchOptions() {
			const options = new Set()

			this.users.forEach((user) => {
				if (user.id) options.add(user.id)
				if (user.auth0?.name) options.add(user.auth0.name)
				if (user.auth0?.email) options.add(user.auth0.email)
			})

			this.searchOptions = Array.from(options).map((option) => ({
				value: option,
				label: option
			}))
		},
		async reloadUsers(globalSearch) {
			try {
				this.loading = true
				let params = this.getSearchParams()

				if (globalSearch) {
					params = { ...params, searchTerm: globalSearch }
				} else if (this.searchField) {
					params.searchTerm = this.searchField
				}

				const response = await usersApi.getAll(params)
				this.totalUsers = response.data.count
				this.users = response.data.results

				const maxPages = Math.ceil(this.totalUsers / this.pageSize) || 1
				if (this.currentPage > maxPages) {
					this.currentPage = 1
					this.reloadUsers(globalSearch)
					return
				}
			} catch (err) {
				console.error(err)
			} finally {
				this.loading = false
			}
		},
		getSearchParams() {
			return {
				order: this.sortColumn,
				dir: this.reverse ? 'asc' : 'desc',
				page: this.currentPage,
				pageSize: this.pageSize
			}
		}
	}
}
</script>
